export default __webpack_public_path__ + "static/nikita-e8f48585dd06b50c6502543cf186bf4a.png";